import { defineMessages } from 'react-intl';

export default defineMessages({
    availableDocuments: {
        id: 'rewrite.common.views.ml-available-documents.Available Documents',
        defaultMessage: 'Available Documents'
    },
    nonUserRetentionText: {
        id: 'rewrite.common.views.ml-available-documents.All the required documents must be signed in order to proceed',
        defaultMessage: 'All the <strong>required documents</strong> must be signed in order to proceed'
    },
    userRetentionText: {
        id: 'rewrite.common.views.ml-available-documents.The following documents must be retained for your records.',
        defaultMessage: 'The <strong>following documents</strong> must be retained for your records.'
    },
    effectiveDate: {
        id: 'rewrite.common.views.ml-available-documents.Effective Date: x',
        defaultMessage: '<strong>Effective Date:</strong> {date}'
    },
    nextDescription: {
        id: 'rewrite.common.views.ml-available-documents.We\'ll confirm your policy next',
        defaultMessage: 'We\'ll <strong>confirm your policy</strong> next'
    },
    bind: {
        id: "rewrite.common.views.ml-available-documents.Binding rewrite",
        defaultMessage: "Binding rewrite"
    },
    bindErrorTitle: {
        id: "rewrite.common.views.ml-available-documents.Unable to bind rewrite",
        defaultMessage: "Unable to bind rewrite"
    },
    bindErrorMessage: {
        id: "rewrite.common.views.ml-available-documents.An error occurred while binding the rewrite",
        defaultMessage: "An error occurred while binding the rewrite"
    },
});